var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 20.9625V24.0025C6 24.2825 6.22 24.5025 6.5 24.5025H9.54C9.67 24.5025 9.8 24.4525 9.89 24.3525L20.81 13.4425L17.06 9.69249L6.15 20.6025C6.05 20.7025 6 20.8225 6 20.9625ZM23.71 10.5425C24.1 10.1525 24.1 9.52249 23.71 9.13249L21.37 6.79249C21.1832 6.60523 20.9295 6.5 20.665 6.5C20.4005 6.5 20.1468 6.60523 19.96 6.79249L18.13 8.62249L21.88 12.3725L23.71 10.5425Z",
    fill: "#ADB8CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDark);
export default __webpack_public_path__ + "static/media/edit_dark.01727c9230920b6f35cec4d5125e0256.svg";
export { ForwardRef as ReactComponent };